<template>
  <div class="modal fade show d-block" v-if="visible" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header position-fixed end-0 top-0 z-3">
          <button v-if="close" type="button" class="btn-close" aria-label="Close" @click="close"></button>
        </div>
        <div class="modal-body text-center pt-4 pb-4">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup-message',
  props: [
      'visible',
      'close'
  ],
}
</script>

<style lang="scss" scoped>
.modal {
  background: black;

  .modal-header {
    border-color: black;

    .btn-close {
      border-radius: 50%;
      font-size: 22px;
      opacity: 1;
      margin-top: -3px;
      margin-right: -1px;
    }
  }

  .modal-content {
    background: black;
    border-color: black;
  }
}
</style>